var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8236 0.858114C11.6128 0.64723 11.2709 0.64723 11.06 0.858114L6.01997 5.89811C5.80909 6.109 5.80909 6.45091 6.01997 6.66179C6.23085 6.87267 6.57276 6.87267 6.78364 6.66179L11.8236 1.62179C12.0345 1.41091 12.0345 1.069 11.8236 0.858114ZM10.7218 3.67667C10.4236 3.67667 10.1818 3.91843 10.1818 4.21667V10.2064C10.1818 10.9185 9.57947 11.5 8.83181 11.5H2.53181C1.78414 11.5 1.18181 10.9185 1.18181 10.2064V3.79353C1.18181 3.08138 1.78414 2.49995 2.53181 2.49995H8.39565C8.69389 2.49995 8.93565 2.25818 8.93565 1.95995C8.93565 1.66172 8.69389 1.41995 8.39565 1.41995H2.53181C1.19151 1.41995 0.101807 2.48072 0.101807 3.79353V10.2064C0.101807 11.5192 1.19151 12.58 2.53181 12.58H8.83181C10.1721 12.58 11.2618 11.5192 11.2618 10.2064V4.21667C11.2618 3.91843 11.02 3.67667 10.7218 3.67667Z",
    fill: "#0D1834"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.3293843d3f4aa59f1c393e150f7c1312.svg";
export { ForwardRef as ReactComponent };